(function ($j) {
	"use strict";

	var $iframeModal = $j("#iframeModal");
	var $iframeModalBody = $j('.modal-body', $iframeModal);

	// Init modal window on click
	$j(".modal-iframe").bind('click touchstart', function ($event) {
		var $iframeTargetElement = $j('iframe', $event.target).clone(false);
		var $iframeSrc = $iframeTargetElement.attr("src");

		// if this is a mobile device, disable the fullscreen option as we have a custom version. 
		// We check height here as well to exclude extra tall phones (iPhone X).
		if ($j(window).width() < 768 && $j(window).height() < 768) {
			$iframeSrc += "&fullscreen=false";
		}

		// Trigger play action via # argument
		if ($iframeSrc.indexOf("#") > 0) {
			$iframeSrc = $iframeSrc.substring(0, $iframeSrc.indexOf("#"));
		}
		$iframeTargetElement.attr("src", $iframeSrc + "#play");

		// Apply layout when desirable
		if ($iframeTargetElement.hasClass("aspect-16-9-content")) {
			$iframeModalBody.addClass("aspect-16-9-container");
		}

		$iframeModalBody.append($iframeTargetElement[0].outerHTML);
		$iframeModal.modal('show');
	});

	// Teardown modal window
	$iframeModal.on('hidden.bs.modal', function () {
		$iframeModalBody.removeClass("aspect-16-9-container");
		$iframeModalBody[0].innerHTML = '';
	});

}(window.$j));
